"use client";
import React from "react";
import { Modal, Spinner } from "react-bootstrap";

interface AppModalProps {
    show: boolean;
    title?: string;
    spinnerText?: string;
    loading?: boolean;
    onHide?: () => void;
}

const AppModal: React.FC<AppModalProps> = ({
    show,
    title,
    spinnerText,
    loading = false,
    onHide,
}) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            backdrop="static"
            keyboard={false}
            contentClassName="border-0"
            dialogClassName="auth-modal-dialog"
        >
            <div
                className="auth-loading-modal-card"
                style={{
                    borderRadius: "12px",
                    overflow: "hidden",
                    minWidth: 320,
                    maxWidth: 380,
                    margin: "0 auto",
                    boxShadow:
                        "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
                }}
            >
                {/* Blue header - only show if title is provided */}
                {title && (
                    <div
                        style={{
                            background:
                                "linear-gradient(135deg, #4f94d4 0%, #3b82f6 100%)",
                            padding: "20px 24px 18px 24px",
                            textAlign: "center",
                            position: "relative",
                        }}
                    >
                        <span
                            style={{
                                color: "#ffffff",
                                fontWeight: 600,
                                fontSize: "18px",
                                fontFamily:
                                    "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
                                letterSpacing: "0.025em",
                            }}
                        >
                            {title}
                        </span>
                    </div>
                )}

                {/* Body - only show if there's content */}
                {(loading || spinnerText) && (
                    <div
                        className="auth-loading-modal-card"
                        style={{
                            padding: title
                                ? "36px 32px 32px 32px"
                                : "32px 32px 32px 32px",
                            textAlign: "center",
                        }}
                    >
                        {loading && (
                            <div style={{ marginBottom: spinnerText ? 28 : 0 }}>
                                <Spinner
                                    animation="border"
                                    style={{
                                        color: "#3b82f6",
                                        width: 42,
                                        height: 42,
                                        borderWidth: "3px",
                                    }}
                                />
                            </div>
                        )}
                        {spinnerText && (
                            <div
                                className="auth-loading-modal-text"
                                style={{
                                    fontSize: "15px",
                                    fontWeight: 400,
                                    lineHeight: 1.5,
                                    fontFamily:
                                        "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
                                    maxWidth: "280px",
                                    margin: "0 auto",
                                }}
                            >
                                {spinnerText}
                            </div>
                        )}
                    </div>
                )}
            </div>
            <style jsx global>{`
                .auth-modal-dialog {
                    max-width: 380px;
                    margin: 0 auto;
                }

                .modal-backdrop {
                    background-color: rgba(0, 0, 0, 0.5);
                }

                .modal-content {
                    background: transparent !important;
                    border: none !important;
                    box-shadow: none !important;
                }
            `}</style>
        </Modal>
    );
};

export default AppModal;
